import {FC} from 'react'

import {CardListLayout} from '@/components/common/cards/CardListLayout'
import {Button} from '@/components/common/content/Button'
import {ArrowIcon} from '@/components/common/icons/ArrowIcon'
import {getTrademarkDisputesContent} from '@/content/trademarkDisputes'
import {Link, useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'
import {TrademarkDisputeSelectedCase} from '@/utils/trademark-disputes/types'

import {IpCaseCard} from './IpCaseCard'

type SelectedIpCasesProps = {
  title?: string
  ipCases: TrademarkDisputeSelectedCase[]
  buttonLinkText?: string
  buttonLinkHref?: string
}

export const SelectedIpCases: FC<SelectedIpCasesProps> = ({
  title,
  ipCases,
  buttonLinkText,
  buttonLinkHref,
}) => {
  const {t} = useTranslation()
  const {selectedCasesTitle, subjectMatterTitle} = getTrademarkDisputesContent()

  return (
    <>
      <CardListLayout title={title ?? t(selectedCasesTitle)}>
        {ipCases.map(({name, linkHref, coverImage, subjectMatter}) => (
          <IpCaseCard
            key={name}
            title={name}
            linkHref={linkHref}
            coverImage={coverImage}
            description={`${t(subjectMatterTitle)}: ${subjectMatter}`}
          />
        ))}
      </CardListLayout>
      {buttonLinkHref && buttonLinkText && (
        <div className="button-wrapper">
          <Link href={buttonLinkHref} prefetch={false}>
            <Button type="button" icon={<ArrowIcon />} isHoverable>
              {buttonLinkText}
            </Button>
          </Link>
        </div>
      )}

      <style jsx>{`
        .button-wrapper {
          width: 100%;
          text-align: center;
          margin-top: ${theme.spacing[7]};
        }
        @media ${TABLET_SCREENSIZE} {
          .button-wrapper {
            margin-top: ${theme.spacing[6]};
          }
        }
      `}</style>
    </>
  )
}
